import {Injectable} from '@angular/core';
import {UserPageResponse} from '@npck/af-frontend-api';
import {RouterService} from '@npck/libs/commons';
import dayjs from 'dayjs';
import {initialTableEvent, TableEvent} from '../components/full-table/full-table.component';
import {Path} from '../path';

@Injectable({providedIn: 'root'})
export class UsersFilterHolderService {
    private tableHolder = this.initialState();

    constructor(
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.ADMIN_PANEL)) {
                    this.clear();
                }
            });
    }

    storeTableState(tableEvent: TableEvent): UsersTableInfo {
        this.tableHolder = {...this.tableHolder, tableEvent};
        return this.tableHolder;
    }

    storeResponse(response: UserPageResponse): void {
        this.tableHolder = {...this.tableHolder, response, cachedTime: dayjs()};
    }

    getState(): UsersTableInfo {
        return this.tableHolder;
    }

    clear(): void {
        this.tableHolder = this.initialState();
    }

    private initialState(): UsersTableInfo {
        return <UsersTableInfo>{
            tableEvent: {
                ...initialTableEvent,
                filter: {tag: {}},
            },
        };
    }
}

export interface UsersTableInfo {
    tableEvent: TableEvent;
    response?: UserPageResponse;
    cachedTime: dayjs.Dayjs;
}
